var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5 24C51.5 36.9787 40.9787 47.5 28 47.5C15.0213 47.5 4.5 36.9787 4.5 24C4.5 11.0213 15.0213 0.5 28 0.5C40.9787 0.5 51.5 11.0213 51.5 24Z",
    fill: "#FF5282",
    stroke: "#FF92B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0558 32.4675C17.0872 31.9292 17.3181 31.2857 17.8395 30.7643C19.9858 28.6154 22.1331 26.4682 24.2786 24.3192C24.6497 23.9482 24.6836 24.0195 24.271 23.6069C22.2137 21.5471 20.154 19.489 18.0976 17.4284C17.8429 17.1728 17.5771 16.9308 17.3852 16.6133C16.8019 15.6522 17.0473 14.3676 17.7427 13.6195C18.399 12.914 19.6157 12.7518 20.5607 13.2281C20.8756 13.3869 21.1507 13.5958 21.4012 13.8471C23.5094 15.9621 25.6218 18.0736 27.7351 20.1844C28.1036 20.5529 28.0416 20.5554 28.4186 20.1708C30.4036 18.1441 32.387 16.1166 34.3704 14.0891C34.5105 13.9464 34.6523 13.8055 34.7907 13.6612C35.6134 12.7951 37.1901 12.6092 38.3083 13.6815C38.9357 14.2827 39.0656 15.0943 38.85 15.9442C38.7167 16.4673 38.4399 16.9011 38.0595 17.2815C36.1916 19.1426 34.3288 21.0088 32.4643 22.8733C32.1731 23.1645 31.8784 23.4541 31.5898 23.7487C31.3741 23.9686 31.3724 23.9771 31.5898 24.1961C32.4974 25.1088 33.4076 26.0182 34.3178 26.9284C35.6168 28.2274 36.9056 29.5366 38.2183 30.8212C39.5156 32.0906 38.9417 34.3728 37.3242 34.9281C36.5083 35.2083 35.7917 35.0164 35.1651 34.4721C34.7321 34.096 34.333 33.6791 33.9221 33.2775C32.0185 31.4181 30.1158 29.557 28.2123 27.6967C28.1766 27.6619 28.1384 27.6288 28.1061 27.5906C27.9754 27.4361 27.854 27.4641 27.7342 27.605C27.6943 27.6526 27.6468 27.6942 27.6026 27.7383C25.4546 29.8847 23.3073 32.032 21.1584 34.1775C21.0174 34.3185 20.8706 34.4569 20.7118 34.5757C19.4102 35.5504 18.0916 34.8975 17.448 33.9636C17.1797 33.5747 17.0541 33.1306 17.0575 32.4675H17.0558Z",
    fill: "#FEFEFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_801",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_801"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_801",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/Wrong.a152ae62aac9f81ec83f4920bd328553.svg";
export { ForwardRef as ReactComponent };